import {
  boolean, date, mixed, number,
  object, ref,
  string,
} from "yup";

import {
  MAX_PAYMENT_DAY_VALUE,
  MIN_PAYMENT_DAY_VALUE,
} from "../../BillingOnboardingModal.constants";

export const validations = [
  object().shape({
    name: string().required(),
    sector: string().required(),
    sectorCode: string().required(),
  }),
  object().shape({
    paymentDayOffset: number().required()
      .min(MIN_PAYMENT_DAY_VALUE).max(MAX_PAYMENT_DAY_VALUE),
    startTime: date().required(),
    endTime: date()
      .required()
      .min(ref("startTime"), "endDateShouldBeHigherThanStartDate"),
  }),
  object().shape({
    isMediumVoltage: boolean().required(),
    isMultiTerm: boolean().required(),
    isPrivate: boolean().required(),
    isGreen: boolean(),
    // Optional validations
    isMultiTime: string().when("isPrivate", (_value: string[], schema) => {
      if (_value[0]) {
        return schema.notRequired();
      }
      return schema.required();
    }),
    margin: mixed().when("isPrivate", (value: string[], schema) => {
      if (!value[0]) {
        return schema.notRequired();
      }
      return number().required();
    }),
    isFixedMargin: mixed().when("isPrivate", (value: string[], schema) => {
      if (!value[0]) {
        return schema.notRequired();
      }
      return boolean().required();
    }),
  }),
  object().shape({
    installationReference: string().required(),
  }),
];
